import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { RichTreeView, TreeItem2 } from '@mui/x-tree-view';

const ProductionGeneratorTree = ({ sourceDataState, treeDataState, expandedItemsState }) => {
  const { sourceData } = sourceDataState;
  const { treeData } = treeDataState;
  const { expandedItems, setExpandedItems } = expandedItemsState;

  const handleExpandedItemsChange = (event, itemIds) => {
    setExpandedItems(itemIds);
  };

  const getItemLabel = (item) => item.relatedItemCode;

  const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
    const findedItem = sourceData.find((item) => item.id === props.itemId);

    const findedItemSourceList = findedItem?.sourceList ?? {};
    const findedItemSourceListOp = findedItemSourceList?.sourceListOperation ?? [];
    return (
      <TreeItem2
        {...props}
        ref={ref}
        sx={{
          color: Object.keys(findedItemSourceList).length > 0 && findedItemSourceListOp.length > 0 ? 'inherit' : 'red',
        }}
      />
    );
  });

  return (
    <Box sx={{ minHeight: 210, minWidth: 250 }} p={1}>
      <RichTreeView
        items={treeData}
        getItemLabel={getItemLabel}
        expandedItems={expandedItems}
        onExpandedItemsChange={handleExpandedItemsChange}
        slots={{
          item: CustomTreeItem,
        }}
      />
    </Box>
  );
};

export default ProductionGeneratorTree;
